<div class="kt-portlet">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title">{{data.title}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body">
				<mat-form-field class="mat-form-field-fluid">
					<input matInput [placeholder]="data.placeholder" [formControl]="inputValue" />
					<mat-error *ngIf="inputValue.invalid && inputValue.touched">
						This field is mandatory
					</mat-error>
					<mat-hint align="start">Please add a
						<strong>comment</strong>
					</mat-hint>
				</mat-form-field>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div class="kt-form__actions kt-form__actions--sm">
				<button mat-raised-button (click)="onCancelClick()">{{data.cancelMessage}}</button>&nbsp;
				<button mat-raised-button (click)="onOkClick()" color="primary" cdkFocusInitial
					[disabled]="viewLoading || disableOkButton">{{data.okMessage}}</button>
			</div>
		</div>
	</div>
</div>